import { react2angular } from 'react2angular';
import type { ILocationService, IScope, IQService } from 'angular';
import angular from 'angular';

import template from './offer_message.html';
import OfferMessageSentPage from './OfferMessageSentPage';
import OfferMessageEditor from './OfferMessageEditor';
import type { OfferMessageProps } from './OfferMessage';
import OfferMessage from './OfferMessage';

interface OfferMessageRouteParams extends ng.route.IRouteParamsService {
  listingId: string;
}

class OfferMessageController {
  constructor(
    private $scope: IScope,
    private $resource: ng.resource.IResourceService,
    private $location: ILocationService,
    private $routeParams: OfferMessageRouteParams,
    private $q: IQService,
    $rootScope: any,
  ) {
    this.listingId = this.$routeParams.listingId;
  }

  private listingId = '';
}

OfferMessageController.$inject = [
  '$scope',
  '$resource',
  '$location',
  '$routeParams',
  '$rootScope',
  'ModalService',
  'ErrorService',
];

angular
  .module('caferealtor.offer.message', ['ngRoute'])

  .config([
    '$routeProvider',
    ($routeProvider: ng.route.IRouteProvider) => {
      $routeProvider.when('/listing/:listingId/offer_message', {
        template,
        controller: OfferMessageController,
        controllerAs: '$ctrl',
      });
    },
  ])

  .component(
    'offerMessage',
    react2angular<OfferMessageProps>(
      OfferMessage,
      ['listingId'],
      ['$scope', '$rootScope', '$location', 'ErrorService', 'ModalService'],
    ),
  )

  .component(
    'offerMessageSentPage',
    react2angular(OfferMessageSentPage, ['listingId']),
  )

  .component(
    'offerMessageEditor',
    react2angular(OfferMessageEditor, [
      'templates',
      'message',
      'signature',
      'setSubject',
      'setBody',
    ]),
  );
